var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.15625V23L8.5 17.9688L0 23V2.15625C0 0.96582 0.951823 0 2.125 0H14.875C16.0482 0 17 0.96582 17 2.15625Z",
    fill: "#2C405A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkSolid);
export default __webpack_public_path__ + "static/media/bookmarkSolid.3fa4f11eb052cce8c9ab4d64d153a34a.svg";
export { ForwardRef as ReactComponent };